import {Editor} from '@di-nxt/components';
import {useCallback, useState} from 'react';
import {t} from '../../../../localization';

type Props = {
  comment: string | undefined;
  onCommentsUpdated: (comments: string) => void;
};

export const CommentEditor: React.FC<Props> = ({
  comment: initialComment,
  onCommentsUpdated,
}) => {
  const [comment, setComment] = useState<string>(initialComment ?? '');
  const updateComment = useCallback(
    (t: string) => {
      setComment(t);
      onCommentsUpdated(t);
    },
    [onCommentsUpdated],
  );

  return (
    <Editor
      placeholder={t('screens.schedule.absencedialog.comments.placeholder')}
      onChange={updateComment}
      value={comment}
      rows={8}
    />
  );
};
